import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { Media } from "./media";
import { Category } from "./category";
import { Genre } from "./genre";

export class Album extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Album' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    song_name: string;

    @JsonProperty({ type: 'string?' })
    album_image_url?: string;

    @JsonProperty({ type: 'string?' })
    cover?: string;

    @JsonProperty({ type: 'string' })
    artist: string;

    @JsonProperty({ type: 'string?' })
    label: string;

    @JsonProperty({ type: 'string?' })
    remixer?: string;

    @JsonProperty({ type: 'string?' })
    artist_info?: string[]

    @JsonProperty({ type: 'string' })
    content_type: 'Audio' | 'Video';

    @JsonProperty({ type: 'number' })
    bpm_count: number;

    @JsonProperty({ type: 'string?' })
    key?: string;

    @JsonProperty({ type: 'number?' })
    total_download_count?: number;

    @JsonProperty({ type: 'boolean' })
    approved: boolean;

    @JsonProperty({ type: 'date' })
    created_at: Date;

    @JsonProperty({ clazz: Category, type: 'Category' })
    category: Category;

    @JsonProperty({ clazz: Genre, type: 'Genre' })
    genre: Genre;

    @JsonProperty({ clazz: Media, type: 'Media?' })
    tracks: Media[];

    @JsonProperty({ type: 'boolean?' })
    has_serato_flip: boolean;

    @JsonProperty({ type: 'boolean?' })
    has_tr_sync: boolean;

    @JsonProperty({ type: 'boolean?' })
    exclusive?: boolean;

    @JsonProperty({ type: 'boolean?' })
    bpm_original?: boolean;

    @JsonProperty({ type: 'any?' })
    depth_analysis?: {
        voice_gender: 'male' | 'female' | 'instrumental' | 'none';
        voice_presence: 'medium' | 'high' | 'low';
        energy_level: 'medium' | 'high' | 'low';
        energy_dynamics: 'low' | 'high';
        mood?: string;
    };
}



// WEBPACK FOOTER //
// ./src/api/src/models/album.ts